import React from 'react';
import { useNavigate } from 'react-router-dom';
import './LandingPage.css';

const HandleidingClienten = () => {
  const navigate = useNavigate();

  const goBack = () => {
    navigate('/');
  };

  return (
    <div>
      {/* Navigation */}
      <nav className="nav">
        <div className="nav-container">
          <div className="logo" onClick={goBack}>RelatieScan</div>
          
          <div className="nav-links">
            <span className="nav-brand">by <strong>PABB</strong></span>
          </div>
        </div>
      </nav>

      {/* Main Content */}
      <section className="section" style={{paddingTop: '120px'}}>
        <div className="container">
          <div style={{maxWidth: '800px', margin: '0 auto'}}>
            
            {/* Header */}
            <div style={{textAlign: 'center', marginBottom: '3rem'}}>
              <h1 className="hero-title" style={{fontSize: '2.5rem', marginBottom: '1rem'}}>
                Handleiding voor Cliënten
              </h1>
              <p className="hero-subtitle" style={{fontSize: '1.2rem', color: '#64748b'}}>
                Hoe vul je de RelatieScan in? Stap-voor-stap uitleg
              </p>
            </div>

            {/* Intro */}
            <div className="benefit-card" style={{marginBottom: '2rem', borderLeft: '4px solid #10b981'}}>
              <h2 className="card-title">Wat is RelatieScan?</h2>
              <p className="card-description">
                RelatieScan is een tool die de therapeut helpt om een eerste indruk an jullie relatie te krijgen, naast de mondelinge intake. Je therapeut heeft je uitgenodigd om 
                50 vragen te beantwoorden over jullie relatie. Dit duurt ongeveer 15 minuten.
              </p>
              
              <div style={{background: '#ecfdf5', padding: '1rem', borderRadius: '8px', marginTop: '1rem'}}>
                <p style={{margin: '0', color: '#047857', fontWeight: '600'}}>
                  <strong>Belangrijk:</strong> Je antwoorden zijn zichtbaar voor je therapeut. Dit helpt bij het therapieproces.
                </p>
              </div>
            </div>

            {/* 1. Uitnodiging Ontvangen */}
            <div className="benefit-card" style={{marginBottom: '2rem'}}>
              <h2 className="card-title">1. Uitnodiging Ontvangen</h2>
              
              <h3 style={{color: '#1e3a8a', marginBottom: '1rem'}}>Email Herkennen</h3>
              <p style={{color: '#64748b', marginBottom: '1rem'}}>Je ontvangt een email met:</p>
              <ul style={{color: '#64748b', lineHeight: '1.8', marginBottom: '1.5rem'}}>
                <li><strong>Onderwerp:</strong> "Uitnodiging voor RelatieScan - [Relatienaam]"</li>
                <li><strong>Afzender:</strong> noreply@pabb.nl</li>
                <li><strong>Inhoud:</strong> Persoonlijke uitnodiging van je therapeut</li>
              </ul>

              <h3 style={{color: '#1e3a8a', marginBottom: '1rem'}}>Belangrijke Details</h3>
              <ul style={{color: '#64748b', lineHeight: '1.8'}}>
                <li>De vragenlijst duurt ongeveer <strong>15 minuten</strong></li>
                <li>Je antwoorden zijn <strong>zichtbaar voor je therapeut</strong></li>
                <li>Je unieke code werkt maar <strong>één keer</strong></li>
                <li><strong>Geen registratie</strong> of account nodig</li>
              </ul>
            </div>

            {/* 2. Vragenlijst Starten */}
            <div className="benefit-card" style={{marginBottom: '2rem'}}>
              <h2 className="card-title">2. Vragenlijst Starten</h2>
              
              <h3 style={{color: '#1e3a8a', marginBottom: '1rem'}}>Stap 1: Link Klikken</h3>
              <ol style={{color: '#64748b', lineHeight: '1.8', marginBottom: '1.5rem'}}>
                <li>Open de uitnodigingsmail</li>
                <li>Klik op <strong>"🔍 Start RelatieScan"</strong></li>
                <li>Je gaat automatisch naar de vragenlijst</li>
                <li>Je unieke code wordt automatisch ingeladen</li>
              </ol>

              <h3 style={{color: '#1e3a8a', marginBottom: '1rem'}}>Stap 2: Vragenlijst Informatie</h3>
              <ul style={{color: '#64748b', lineHeight: '1.8'}}>
                <li><strong>25 vragen</strong> over relatie en samenwerking</li>
                <li><strong>4-punts schaal:</strong> Volledig oneens → Volledig eens</li>
                <li><strong>5 categorieën:</strong> Vertrouwen, Conflicten, Commitment, Verantwoording, Resultaten</li>
                <li><strong>Voortgangsbalk</strong> toont hoe ver je bent</li>
              </ul>
            </div>

            {/* 3. Vragenlijst Invullen */}
            <div className="benefit-card" style={{marginBottom: '2rem'}}>
              <h2 className="card-title">3. Vragenlijst Invullen</h2>
              
              <h3 style={{color: '#1e3a8a', marginBottom: '1rem'}}>Tips voor Eerlijke Antwoorden</h3>
              <ol style={{color: '#64748b', lineHeight: '1.8', marginBottom: '1.5rem'}}>
                <li><strong>Denk aan je huidige relatie</strong> - niet aan eerdere relaties</li>
                <li><strong>Wees eerlijk</strong> - dit helpt je therapeut je het beste te kunnen begeleiden</li>
                <li><strong>Volg je eerste instinct</strong> - niet te lang nadenken</li>
                <li><strong>Alle vragen verplicht</strong> - je kunt geen vragen overslaan</li>
              </ol>

              <h3 style={{color: '#1e3a8a', marginBottom: '1rem'}}>Voorbeeld Vragen</h3>
              <div style={{background: '#f8fafc', padding: '1rem', borderRadius: '8px', marginBottom: '1.5rem'}}>
                <ul style={{color: '#64748b', lineHeight: '1.8', margin: '0'}}>
                  <li>"Partners geven openlijk toe als ze een fout maken in de relatie"</li>
                  <li>"Er worden moeilijke onderwerpen besproken in onze relatie"</li>
                  <li>"Beide partners zijn betrokken bij het welslagen van de relatie"</li>
                </ul>
              </div>

              <h3 style={{color: '#1e3a8a', marginBottom: '1rem'}}>Technische Tips</h3>
              <ul style={{color: '#64748b', lineHeight: '1.8'}}>
                <li><strong>Stabiele internetverbinding</strong> aanbevolen</li>
                <li><strong>15 minuten tijd</strong> reserveren (zonder onderbrekingen)</li>
                <li><strong>Moderne browser</strong> gebruiken (Chrome, Firefox, Safari, Edge)</li>
              </ul>
            </div>

            {/* 4. Vragenlijst Voltooien */}
            <div className="benefit-card" style={{marginBottom: '2rem'}}>
              <h2 className="card-title">4. Vragenlijst Voltooien</h2>
              
              <h3 style={{color: '#1e3a8a', marginBottom: '1rem'}}>Na de Laatste Vraag</h3>
              <ol style={{color: '#64748b', lineHeight: '1.8', marginBottom: '1.5rem'}}>
                <li>Klik <strong>"Vragenlijst Voltooien"</strong></li>
                <li>Je ziet een bevestigingspagina</li>
                <li><strong>Bedankt bericht</strong> met vervolgstappen</li>
                <li>Je kunt het browsertabblad sluiten</li>
              </ol>

              <div style={{background: '#fef3c7', padding: '1rem', borderRadius: '8px'}}>
                <h4 style={{color: '#92400e', margin: '0 0 0.5rem 0'}}>Je Code is Nu Gebruikt</h4>
                <ul style={{margin: '0', color: '#92400e', lineHeight: '1.6'}}>
                  <li>Je unieke code werkt niet meer</li>
                  <li>Je kunt de vragenlijst niet opnieuw invullen</li>
                  <li>Vragen? Neem contact op met je therapeut</li>
                </ul>
              </div>
            </div>

            {/* 5. Wat Gebeurt Er Nu */}
            <div className="benefit-card" style={{marginBottom: '2rem'}}>
              <h2 className="card-title">5. Wat Gebeurt Er Nu?</h2>
              
              <h3 style={{color: '#1e3a8a', marginBottom: '1rem'}}>Wachten op Resultaten</h3>
              <ul style={{color: '#64748b', lineHeight: '1.8', marginBottom: '1.5rem'}}>
                <li>Je therapeut ziet wanneer jij de vragenlijst hebt voltooid</li>
                <li>Resultaten zijn beschikbaar als <strong>beide partners</strong> klaar zijn</li>
                <li>Je ontvangt <strong>geen automatische</strong> resultaten</li>
              </ul>

              <h3 style={{color: '#1e3a8a', marginBottom: '1rem'}}>Resultaten Ontvangen</h3>
              <ul style={{color: '#64748b', lineHeight: '1.8', marginBottom: '1.5rem'}}>
                <li>Je therapeut kan het rapport met jullie delen</li>
                <li>Je therapeut ziet beide individuele antwoorden</li>
                <li>Dit helpt bij het bepalen van de therapiefocus</li>
              </ul>

              <h3 style={{color: '#1e3a8a', marginBottom: '1rem'}}>Vervolgstappen</h3>
              <ul style={{color: '#64748b', lineHeight: '1.8'}}>
                <li>Therapiesessie om de resultaten te bespreken</li>
                <li>Samen werken aan verbeterpunten</li>
                <li>Eventuele follow-up RelatieScan na verbetertijd</li>
              </ul>
            </div>

            {/* Problemen */}
            <div className="benefit-card" style={{marginBottom: '2rem', borderLeft: '4px solid #f59e0b'}}>
              <h2 className="card-title">Problemen of Vragen?</h2>
              
              <h3 style={{color: '#1e3a8a', marginBottom: '1rem'}}>Veel Voorkomende Problemen</h3>
              
              <h4 style={{color: '#059669', marginBottom: '0.5rem'}}>Vragenlijst-link werkt niet?</h4>
              <ol style={{color: '#64748b', lineHeight: '1.8', marginBottom: '1rem'}}>
                <li>Controleer of je de juiste link uit de email gebruikt</li>
                <li>Probeer een andere browser of incognito modus</li>
                <li>Contact je therapeut voor een nieuwe uitnodiging</li>
              </ol>

              <div style={{background: '#fef2f2', padding: '1rem', borderRadius: '8px'}}>
                <p style={{margin: '0', color: '#991b1b'}}>
                  <strong>Belangrijke regel:</strong> De vragenlijst moet in één keer worden afgemaakt. 
                  Je kunt niet pauzeren en later verder gaan. Reserveer 15 minuten ononderbroken tijd.
                </p>
              </div>
            </div>

            {/* Contact */}
            <div className="benefit-card" style={{marginBottom: '2rem', borderLeft: '4px solid #ef4444'}}>
              <h2 className="card-title">Contact bij Problemen</h2>
              <p style={{color: '#64748b', marginBottom: '1rem'}}>
                Voor technische problemen of vragen kun je contact opnemen:
              </p>
              <ul style={{color: '#64748b', lineHeight: '1.8'}}>
                <li><strong>Email:</strong> diederik@tractum.nl</li>
                <li><strong>Eerste hulp:</strong> Vraag je therapeut om hulp</li>
                <li><strong>RelatieScan website:</strong> <a href="https://relatiescan.pabb.nl" style={{color: '#3b82f6'}}>https://relatiescan.pabb.nl</a></li>
              </ul>
            </div>

            {/* Navigation */}
            <div style={{textAlign: 'center', marginTop: '3rem'}}>
              <button 
                className="secondary-button" 
                onClick={goBack}
                style={{marginRight: '1rem'}}
              >
                ← Terug naar RelatieScan
              </button>
              </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default HandleidingClienten;